import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { getSubCategory } from "../../services/subcategory.service";
import { useSelector } from "react-redux";
import { getAllMainCategories } from "../../services/category.service";

export default function SubCategoryDetails() {
  const { token } = useSelector((state) => state?.auth);
  const [subCategory, setSubCategory] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const subCategoryId = params.get("id");

  const fetchSubCategory = async () => {
    try {
      const res = await getSubCategory(token, subCategoryId);
      if (res && res.status >= 200 && res.status < 300) {
        setSubCategory(res?.data);
      } else {
        Swal.fire(
          "Error",
          "Failed to fetch sub-category details. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching sub-category:", error);
      Swal.fire(
        "Error",
        "An error occurred while fetching the sub-category. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (subCategoryId) {
      fetchSubCategory();
    }
  }, [subCategoryId]);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Sub Category Details</h4>
                <Link to="/sub-categories">
                  <img
                    src="/assets/images/kidskart/icon/back-button.png"
                    alt="Back"
                  />
                </Link>
              </div>
              <div className="card-body">
                <div className="row">
                  {/* Main Category */}
                  <div className="col-sm-6 mb-4">
                    <h5>Main Category</h5>
                    <p>{subCategory?.main_category_name || "N/A"}</p>
                  </div>

                  {/* Sub Category */}
                  <div className="col-sm-6 mb-4">
                    <h5>Sub Category</h5>
                    <p>{subCategory?.sub_category_name || "N/A"}</p>
                  </div>

                  {/* Image */}
                  <div className="col-sm-6 mb-4">
                    <h5>Image</h5>
                    {subCategory?.image ? (
                      <img
                        src={subCategory?.image}
                        alt="Sub Category"
                        className="img-thumbnail w-25"
                        style={{ width: "200px" }}
                      />
                    ) : (
                      <p>No Image Available</p>
                    )}
                  </div>

                  {/* Description */}
                  <div className="col-md-6 mb-4">
                    <h5>Description</h5>
                    <p>
                      {subCategory?.description || "No description provided"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
